import React from 'react';
import { FilterProps, LOCATIONS_FILTER } from './types';
import { useObjectLabels } from '../../../../../hooks/useObjectLabels';
import TeamCalendarMultipleFilter from './TeamCalendarMultipleFilter';

const OfficeFilter: React.FC<React.PropsWithChildren<FilterProps>> = ({
  options,
  filterData,
}) => {
  const objectLabels = useObjectLabels();

  return (
    <TeamCalendarMultipleFilter
      options={options}
      filterData={filterData}
      filterKey={LOCATIONS_FILTER}
      placeholder={objectLabels.location}
    />
  );
};

export default OfficeFilter;
